export const environment = {
  production: false,
  title: 'pvr-funcionarios development environment',
};
